module.exports = __webpack_public_path__ + "img/20190904164105360截图20190904160248001.fa4bac7e.jpg";